
// Attributes
// data-entry-tool = [data-entry-tool-type] data-entry-tool-name

// data-entry-tool, data-entry-tool-type, data-entry-tool-name, 
// data-cta-text, data-thank-you-slug, data-submission-callback-name
// data-attribution-survey-value


let jetFormCounter = 0;


function initJetForm(container) {

  if (container.hasAttribute('data-jet-form-initialized')) {
    return;
  }
  container.setAttribute('data-jet-form-initialized', 'true');

  const index = jetFormCounter++;

  //iframe id
  container.id = 'container-jet-form-' + index;
  const iframeId = 'iframe-jet-form-' + index;


  //jet id
  const jetId = window.JetConversions?.getJetId() || '';

  if (!jetId || jetId === "") {
    try {
      window.posthog?.capture("jet_form_empty_jet_id", {
        tracker_present: !!window.JetConversions,
        cookie_jet_id_present: document.cookie.indexOf("_jet_id=") !== -1,
        is_iframe: window.self !== window.top,
        readystate: document.readyState,
        href: location.href,
        referrer: document.referrer,
      });
    } catch (e) { }
  }

  //entry channel
  const utmParams = window.JetConversions?.getUtm() || {};

  //entry place
  const entryType = "form";
  const entryWebpageUri = window.location.href;
  const entryWebpageName = document.title;
  const entryWebpagePath = window.location.origin + window.location.pathname;
  const entryToolValue = container.getAttribute('data-entry-tool');
  let entryToolType = container.getAttribute('data-entry-tool-type') || 'demo';

  if (entryToolType.toLocaleLowerCase() === 'webinar on-demand') {
    entryToolType = 'webinar';
  }


  const entryToolName = container.getAttribute('data-entry-tool-name') || 'missing';
  const entryTool = entryToolValue || `[${entryToolType.toLocaleLowerCase()}] ${entryToolName}`;

  //form customization
  const ctaText = container.getAttribute('data-cta-text') || '';
  const attributionSurveyValue = container.getAttribute('data-attribution-survey-value') || '';
  const thankYouSlugValue = container.getAttribute('data-thank-you-slug') || '';
  const submissionCallbackName = container.getAttribute('data-submission-callback-name') || '';

  const domain = window.location.origin;
  let baseUrl = 'https://join.jethr.com/richiesta-demo';

  if (domain.includes('webflow')) {

    const parentParams = new URLSearchParams(window.location.search);
    const devUrl = parentParams.get('dev-url');

    if (devUrl) {
      baseUrl = devUrl + 'richiesta-demo';
    } else {
      baseUrl = 'https://self-acquisition-staging.web.app/richiesta-demo';
    }
  }

  const params = new URLSearchParams({

    jet_id: jetId,

    ...utmParams,

    entry_type: entryType,
    entry_webpage_uri: entryWebpageUri,
    entry_webpage_name: entryWebpageName,
    entry_webpage_path: entryWebpagePath,
    entry_tool: entryTool,

    attribution_survey: attributionSurveyValue,
    cta_text: ctaText,
    thank_you_slug: thankYouSlugValue,
    submission_callback_name: submissionCallbackName,

    iframe_id: iframeId,
    is_mobile: window.innerWidth < 768,
  });

  window.posthog.capture("jet_form_created", {
    jet_id: jetId,
    entry_type: entryType,
    entry_webpage_uri: entryWebpageUri,
    entry_webpage_name: entryWebpageName,
    entry_webpage_path: entryWebpagePath,
    entry_tool: entryTool,
    attribution_survey: attributionSurveyValue,
    cta_text: ctaText,
    thank_you_slug: thankYouSlugValue,
    submission_callback_name: submissionCallbackName,
    iframe_id: iframeId,
    is_mobile: window.innerWidth < 768,
  });

  const urlWithParams = `${baseUrl}?${params.toString()}`;

  container.innerHTML = `
    <iframe
      id="${iframeId}"
      src="${urlWithParams}"
      width="100%"
      scrolling="no"
      style="border: none;">
    </iframe>
  `;
}

window.addEventListener("message", (event) => {

  const type = event.data?.type;
  const iframeId = event.data?.iframeId;

  if (type === "REQUEST_DEMO_HEIGHT") {

    const iframe = document.getElementById(iframeId);
    if (iframe) {
      iframe.height = `${event.data.height}px`;
    }

  } else if (type === "REQUEST_DEMO_DONE") {

    let thankYouSlugValue = event.data.thankYouSlug;
    const submissionCallbackName = event.data.submissionCallbackName;

    if (submissionCallbackName && typeof window[submissionCallbackName] === 'function') {

      window[submissionCallbackName]();
      document.querySelector('#popup-close-demo')?.click();

    } else {

      const domain = window.location.origin;

      if (thankYouSlugValue) {
        if (thankYouSlugValue.charAt(0) !== '/') {
          thankYouSlugValue = '/ty/' + thankYouSlugValue;
        }
      } else {
        thankYouSlugValue = '/thank-you';
      }

      window.location.href = domain + thankYouSlugValue;
      document.querySelector('#popup-close-demo').click();

    }

  }

});

document.addEventListener("DOMContentLoaded", () => {

  // Initialize existing forms
  document.querySelectorAll(".jet-form").forEach(initJetForm);

  // Observer for dynamic forms
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element
          if (node.classList && node.classList.contains("jet-form")) {
            initJetForm(node);
          }
          // Also check inside the added node (e.g. if a container with the form inside was added)
          if (node.querySelectorAll) {
            node.querySelectorAll(".jet-form").forEach(initJetForm);
          }
        }
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }

});
